module.exports = __webpack_public_path__ + "static/media/wor_clo_to_wat_wor_pla.df0c84c3.png";